import {pegarProporcoesDeImagem} from "@/utils/pegarProporcoesDeImagem";

export async function criarGoogleDocs(questoes, titulo) {
    try {
        // Criar o documento no Google Docs
        const docResponse = await gapi.client.docs.documents.create({
            'title': titulo
        });
        const documentId = docResponse.result.documentId;
        console.log("Documento criado:", documentId);


        // Preparar os pedidos de atualização do documento
        let requests = [            
           

             {
                 updateDocumentStyle: {
                     documentStyle: {
                         marginLeft: { magnitude: 50, unit: 'PT' },
                         marginRight: { magnitude: 50, unit: 'PT' },
                         marginTop: { magnitude: 50, unit: 'PT' },
                         marginBottom: { magnitude: 50, unit: 'PT' },
                     },
                     fields: 'marginLeft,marginRight, marginTop, marginBottom'
                 }
             }
        ];

        // define o index (lugar) onde inserir o próximo texto
        let currentIndex = 1;


        // adicionar título da atividade e formatar
        requests.push(
            {
                insertText: {
                    location: {
                        index: currentIndex, // Inserir no início do documento
                    },
                    text: titulo + '\n'
                }
            },
            // Formatar o título
            {
                updateTextStyle: {
                    range: { startIndex: currentIndex, endIndex: currentIndex + titulo.length + 1 },
                    textStyle: {
                        weightedFontFamily: { fontFamily: 'Arial', weight: 700 },
                        fontSize: { magnitude: 17, unit: 'PT' },
                        bold: true
                    },
                    fields: 'weightedFontFamily,fontSize,bold'
                }
            },
        )


        currentIndex += titulo.length + 1;

        const nomeETurma = "Nome: ________________________                                         Turma:  ________________________" ;
        requests.push({
            insertText: {
                location: {
                    index: currentIndex, // Inserir no início do documento
                },
                text: nomeETurma + '\n'
            }
        })

        currentIndex += nomeETurma.length + 1;


        requests.push(
            {
                insertSectionBreak: {
                    location: {
                        index: currentIndex
                    },
                    sectionType: 'CONTINUOUS'
                }
            }
        )

        for (const [index, questao] of questoes.entries()) {
            // Insere o número da questão e o texto da questão
            let questionText = `Questão ${index + 1}\n`;
            requests.push({
                insertText: {
                    location: { index: currentIndex },
                    text: questionText
                }
            });

            // Definir os índices onde o estilo será aplicado para o texto da questão
            let textStartIndex = currentIndex;
            let textEndIndex = currentIndex + questionText.length;

            // Aplicar estilo ao texto da questão
            requests.push({
                updateTextStyle: {
                    range: { startIndex: textStartIndex, endIndex: textEndIndex },
                    textStyle: {
                        bold: true,
                        fontSize: { magnitude: 12, unit: 'PT' }
                    },
                    fields: 'bold,fontSize'
                }
            });

            // Adicionar espaço antes da questão
            requests.push({
                updateParagraphStyle: {
                    range: { startIndex: textStartIndex, endIndex: textEndIndex },
                    paragraphStyle: {
                        spaceAbove: { magnitude: 10, unit: 'PT' }
                    },
                    fields: 'spaceAbove'
                }
            });

            // Atualiza o currentIndex para o próximo ponto de inserção de texto
            currentIndex += questionText.length;


            // Inserir imagem, se houver
            if (questao.imagem) {
                let dimensoes = await pegarProporcoesDeImagem(questao.imagem, 320);


                requests.push({
                    insertInlineImage: {
                        location: {
                            index: currentIndex
                        },
                        uri: questao.imagem,
                        objectSize: {
                            height: { magnitude: dimensoes.height, unit: 'PT' },
                            width: { magnitude: dimensoes.width, unit: 'PT' }
                        }
                    }
                });
                // Adiciona uma nova linha após a imagem
                requests.push({
                    insertText: {
                        location: {
                            index: currentIndex + 1
                        },
                        text: '\n'
                    }
                });
                currentIndex += 2; // Ajuste conforme necessário dependendo do tamanho do texto após a imagem
            }

            // Adiciona o texto de apoio, se houver
            if (questao.texto) {
                let textLength = questao.texto.length + 1;

                requests.push({
                    insertText: {
                        location: {
                            index: currentIndex
                        },
                        text: questao.texto + '\n'
                    }
                });

                // Adicionar espaço depois do texto
                requests.push({
                    updateParagraphStyle: {
                        range: { startIndex: currentIndex, endIndex: currentIndex + textLength },
                        paragraphStyle: {
                            spaceBelow: { magnitude: 6, unit: 'PT' }
                        },
                        fields: 'spaceBelow'
                    }
                });
                currentIndex += textLength;
            }




            // Adiciona a pergunta
            requests.push({
                insertText: {
                    location: {
                        index: currentIndex
                    },
                    text: questao.pergunta + '\n'
                }
            });
            currentIndex += questao.pergunta.length + 1;

            // Adiciona as alternativas
            ['a', 'b', 'c', 'd', 'e'].forEach(letter => {
                if (questao[letter]) {
                    requests.push({
                        insertText: {
                            location: {
                                index: currentIndex
                            },
                            text: `${letter}) ${questao[letter]}\n`
                        }
                    });
                    currentIndex += `${letter}) ${questao[letter]}\n`.length;
                }
            });

            
        }

        // Executar os pedidos para atualizar o documento
        const batchUpdateResponse = await gapi.client.docs.documents.batchUpdate({
            documentId: documentId,
            resource: {
                requests: requests
            }
        });
        console.log("Documento atualizado com sucesso.", batchUpdateResponse.result);

        return { status: 'sucesso', docId: documentId};
    } catch (error) {
        console.error("Erro ao criar ou atualizar o documento:", error);
        return { status: 'erro', erro: error.result.error.message };
    }
}





